import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Component, OnInit, Inject} from '@angular/core';

@Component({
  selector: 'app-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss']
})
export class DialogConfirmComponent implements OnInit {

  message: String = '';
  confirmButtonText = 'Sim';
  cancelButtonText = 'Cancelar';
  from;
  showTable = false;
  aspect;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any,
              private dialogRef: MatDialogRef<DialogConfirmComponent>) {
    console.log(data);
    this.from = data.from;
    if (this.from === 'caixa.component.ts') {
      this.cancelButtonText = 'Não, apenas salvar';
    }
    if (this.from === 'vincular-aspecto-ponto-acesso.ts') {
      this.cancelButtonText = 'Não, apenas vincular';
    }
    if (this.from === 'save-propertie-dialog.component.ts_vincular') {
      this.showTable = true;
      this.aspect = data.aspecto;
      console.log(this.aspect);
    }
  }

  ngOnInit() {
    this.message = this.data.name;
  }

  onConfirmClick(): void {
    this.dialogRef.close({apagar: true});
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/dialog/dialog-confirm/dialog-confirm.component.ts